import { Component } from '@angular/core';

@Component({
  selector: 'app-dashboard-component-list',
  standalone: false,
  templateUrl: './dashboard-component-list.component.html',
  styleUrl: './dashboard-component-list.component.scss'
})
export class DashboardComponentListComponent {

}
